(function (app) {

    app.provider("stockQuestionApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", function (complianceHubApiGateway) {
                        var service = {};

                        //GETs
                        service.getStockQuestion = function (stockQuestionId) {
                            return complianceHubApiGateway.get("/StockQuestions/" + stockQuestionId);
                        }

                        service.getAllStockQuestions = function () {
                            return complianceHubApiGateway.getArray("/StockQuestions/All");
                        };

                        service.getAllRightBridgeQuestions = function () {
                            return complianceHubApiGateway.getArray("/StockQuestions/AllRightBridge");
                        }

                        service.getAllFirelightQuestions = function () {
                            return complianceHubApiGateway.getArray("/StockQuestions/AllFireLight");
                        }

                        service.getFirelightQuestion = function (firelightQuestionId) {
                            return complianceHubApiGateway.get("/StockQuestions/FirelightQuestion/" + firelightQuestionId);
                        }

                        service.getRightBridgeQuestion = function (rightBridgeQuestionId) {
                            return complianceHubApiGateway.get("/StockQuestions/RightBridgeQuestion/" + rightBridgeQuestionId);
                        }

                        //PUTs
                        service.updateStockQuestion = function (stockQuestion) {
                            return complianceHubApiGateway.put("/StockQuestions/" + stockQuestion.Id, stockQuestion);
                        };

                        service.updateFirelightQuestion = function (firelightQuestion) {
                            return complianceHubApiGateway.put("/StockQuestions/FirelightQuestion/" + firelightQuestion.FirelightQuestionId, firelightQuestion);
                        }

                        service.updateRightBridgeQuestion = function (rightBridgeQuestion) {
                            return complianceHubApiGateway.put("/StockQuestions/RightBridgeQuestion/" + rightBridgeQuestion.RightBridgeQuestionId, rightBridgeQuestion);
                        }

                        //POSTs
                        service.createStockQuestion = function (stockQuestion) {
                            return complianceHubApiGateway.post("/StockQuestions/", stockQuestion);
                        };

                        service.createFirelightQuestion = function (question) {
                            return complianceHubApiGateway.post("/StockQuestions/FirelightQuestion", question);
                        }

                        service.createRightBridgeQuestion = function (question) {
                            return complianceHubApiGateway.post("/StockQuestions/RightBridgeQuestion", question);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app);